import { RichTextRenderer as OriginalRichTextRenderer } from '@pba/react-rich-text-editor';
import type { ComponentProps } from 'react';
import { Image } from '../image';

type P = ComponentProps<typeof OriginalRichTextRenderer>;

const RichTextRenderer = (props: P) => (
  <OriginalRichTextRenderer Image={Image} PreviewGroup={Image.PreviewGroup} {...props} />
);

export default RichTextRenderer;
